<template>
  <div class="task-container">
    <TaskTabHeader :activeTaskTab="activeTaskTab" @tab-change="handleTabChange" />
    <TaskFilter 
      @open-create-task="openCreateTaskModal"
      @filter-search="handleFilterSearch"
      @filter-due-date="handleFilterDueDate"
      @filter-creation-date="handleFilterCreationDate"
    />
    <div class="task-table-wrapper">
      <TaskTable 
        class="h-full w-full"
        :task-data="taskData" 
        :activeTaskTab="activeTaskTab" 
        @open-create-task="openCreateTaskModal"
      />
    </div>
    <ScheduleDetail
      :visible="showDetail"
      :active-tab="'task'"
      :hide-switch-tab="true"
      @close="closeDetail"
    />
    
  </div>
</template>

<script setup>
import { ref,computed,onMounted,watch } from 'vue'
import TaskTabHeader from './TaskTabHeader.vue'
import TaskFilter from './TaskFilter.vue'
import TaskTable from './TaskTable.vue'
import ScheduleDetail from '../schedule/ScheduleDetail.vue'
import moment from 'moment-timezone'
import { useStore } from 'vuex'

const activeTaskTab = ref('myTasks')

const filterDueDate = ref('')
const filterCreationDate = ref('')
const filterSearch = ref('')
const handleFilterDueDate = (date) => { filterDueDate.value = date }
const handleFilterCreationDate = (date) => { filterCreationDate.value = date }
const handleFilterSearch = (value) => { filterSearch.value = value }

const store = useStore()
const calendarTimezone = computed(() => store.getters['calendar/calendarTimezone'])
// const userInfo = computed(() => JSON.parse(localStorage.getItem("userInfo")))
const rawTaskData = computed(() => {
  return [...store.state.calendar.rawTaskInfoList].filter(task => task?.is_active !== false)
})

const providerTaskData = computed(() => {
  return rawTaskData.value.filter(task => {
    // userinfo todo
    const isProviderTask = task.calendar_id === store.state.calendar.creatorCalendarId;
    if (!isProviderTask) return false;
    // filter due date
    if (filterDueDate.value) {
      const taskDue = task.due_date
        ? moment.utc(task.due_date).tz(calendarTimezone.value).format('YYYY-MM-DD')
        : '';
      if (taskDue !== filterDueDate.value) return false;
    }
    // filter creation date
    if (filterCreationDate.value) {
      const taskCreated = task.created_at
        ? moment.utc(task.created_at).tz(calendarTimezone.value).format('YYYY-MM-DD')
        : '';
      if (taskCreated !== filterCreationDate.value) return false;
    }
    // filter search
    if (filterSearch.value) {
      const title = task.title
        ? task.title.toLowerCase()
        : '';
      if (!title.includes(filterSearch.value.toLowerCase())) return false;
    }
    return true;
  });
});

const patientTaskData = computed(() => {
  return rawTaskData.value.filter(task => {
    // userinfo todo
    const isPatientTask = task.calendar_id !== store.state.calendar.creatorCalendarId;
    // console.log(store.state.calendar.creatorCalendarId,'creatorCalendarId')
    if (!isPatientTask) return false;
    // filter due date
    if (filterDueDate.value) {
      const taskDue = task.due_date
        ? moment.utc(task.due_date).tz(calendarTimezone.value).format('YYYY-MM-DD')
        : '';
      if (taskDue !== filterDueDate.value) return false;
    }
    // filter creation date
    if (filterCreationDate.value) {
      const taskCreated = task.created_at
        ? moment.utc(task.created_at).tz(calendarTimezone.value).format('YYYY-MM-DD')
        : '';
      if (taskCreated !== filterCreationDate.value) return false;
    }
    // filter search
    if (filterSearch.value) {
      const taskName = task.title
        ? task.title.toLowerCase()
        : '';
      if (!taskName.includes(filterSearch.value.toLowerCase())) return false;
    }
    return true;
  });
});
const taskData = computed(() => {
  return activeTaskTab.value === 'myTasks' ? providerTaskData.value : patientTaskData.value
})

const showDetail = ref(false)
const closeDetail = () => { 
  showDetail.value = false 
  store.dispatch('calendar/setCurrentTaskInfo', null)

}
const openCreateTaskModal = () => {
  showDetail.value = true
}

const handleTabChange = (tab) => { activeTaskTab.value = tab }
const createOrUpdateEventAction = computed(() => store.state.calendar.createOrUpdateEventAction)

watch(createOrUpdateEventAction, async (newVal) => {
  if (!newVal) {
    store.dispatch('calendar/setTaskLoading', true)
    await store.dispatch('calendar/fetchTasks')
    store.dispatch('calendar/setTaskLoading', false)
  }
})

onMounted(async () => {
  store.dispatch('calendar/setTaskLoading', true)
  await store.dispatch('calendar/fetchTasks')
  store.dispatch('calendar/setTaskLoading', false)
})


</script>

<style scoped>
.task-container{
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: #fff;
  margin-right: 16px;
  margin-bottom: 16px;
  border-top: 1px dashed #C9CACD;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.task-table-wrapper{
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

</style>
